@use '@lib/assets/styles/main.scss' as *;
@use '@lib/components/Select/SelectExtends' as *;
@use './input-vars' as *;
@use './Default.module' as *;
@use './Input.module' as *;
@use "./flags.module" as *;

:root {
  .react-tel-input {
    position: relative;
    width: 100%;

    @extend %flags;

    :disabled {
      cursor: not-allowed
    }

    .hide {
      display: none
    }

    .v-hide {
      visibility: hidden
    }

    .form-control {
      @extend .input, .inputLarge;
      padding-left: $inputTelLeftHorizontalPadding;

      &.invalid-number {
        @extend .inputWithError;
      }

      &.invalid-number:focus {
        box-shadow: inset 0 0 0 1px $error900;
      }

      &--hasError {
        @extend .inputWithError;
      }
    }

    .flag-dropdown {
      &:hover,
      &:focus {
        cursor: pointer
      }
    }

    input[disabled] + .flag-dropdown:hover {
      cursor: default
    }

    .selected-flag {
      position: absolute;
      left: 1px;
      top: 50%;
      transform: translateY(-50%);
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;

      .arrow {
        width: 24px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(100%, -50%);
        transition: transform .3s ease;
        &.up {
          transform: translate(100%, -50%) rotate(180deg);
        }

        &::before {
          content: '\e5c5';
          font-family: "Material Icons";
          font-size: 24px;
          color: $gray700;
          display: block;
        }
      }
    }

    .country-list {
      @extend %dropDownStyle;
      padding: 8px 0;
      outline: none;
      list-style: none;
      position: absolute !important;
      top: 100% !important;
      left: 0 !important;
      transform: unset !important;
      width: 100%;
      max-height: 200px;
      overflow-y: scroll;

      .divider {
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid #ccc
      }

      .country {
        @include dropDownItemStyle;
        .dial-code {
          color: $gray500
        }
      }

      .flag {
        width: 24px;
        margin-right: 12px;
        display: flex;
        justify-content: center;
      }

      .country-name {
        margin-right: 6px
      }

      .search {
        position: sticky;
        top: 0;
        background-color: #fff;
        padding: 10px 0 6px 10px
      }

      .search-emoji {
        font-size: 15px
      }

      .search-box {
        border: 1px solid #cacaca;
        border-radius: 3px;
        font-size: 15px;
        line-height: 15px;
        margin-left: 6px;
        padding: 3px 8px 5px;
        outline: none
      }

      .no-entries-message {
        padding: 7px 10px 11px;
        opacity: .7
      }
    }

    .invalid-number-message {
      position: absolute;
      z-index: 1;
      font-size: 13px;
      left: 46px;
      top: -8px;
      background: #fff;
      padding: 0 2px;
      color: #de0000
    }

    .special-label {
      display: none;
    }
  }
}
